import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AddrModalService } from './addr-modal.service';
@Component({
  selector: 'app-addr-modal',
  templateUrl: './addr-modal.component.html',
  styleUrls: ['./addr-modal.component.scss'],
  providers: [AddrModalService],
})
export class AddrModalComponent implements OnInit {
  // @Input() isShow: false;
  @Input() display:boolean =  false;
  @Output() isDisplay: any = new EventEmitter();
  @Output() selectCityId: any = new EventEmitter();

  public city_name: string = "全国";   //当前城市
  public cityList: Array<Object> = []; //城市列表
  constructor(
    private _addrModalService: AddrModalService,
  ) { }
  ngOnInit() {
    //获取城市列表
    this.getCityList();
  }
  //获取城市列表
  getCityList() {
    this._addrModalService.getCityList().then(resp => { //请求城市信息
      if (resp.success) {
        this.cityList = resp['data'];     //城市列表赋值
      } else {
        // alert(resp['msg)']);              //提示错误信息
      }
    })
  }
  // 返回模态框状态  display
  targetDialog() {
    this.isDisplay.emit(this.display);
  }
  //返回选中值
  getCityID(event) {
    this.city_name = event.name;
    this.display = false;
    this.isDisplay.emit(this.display);    //返回 模态框状态
    this.selectCityId.emit(event);       //返回选中城市信息  $evnet
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/addr-modal/addr-modal.component.ts